// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"antd-pro-pages-editor-flow-components-editor-toolbar-index-toolbar","tooltip":"antd-pro-pages-editor-flow-components-editor-toolbar-index-tooltip"};